export default ['$http', '$q', snowballService]

function snowballService($http, $q) {
  this.fetchSuggestions = function(textBody) {
    return $http({
      method: 'POST',
      url: '/snowball/service/ellipsis/suggest.json',
      data: {
        sample: textBody,
      },
    }).then(function(response) {
      return response.data.suggestions
    })
  }
  this.eatStoryObj = function(rawStoryObj) {
    const textBody = []
    for (let idx = 0; idx < rawStoryObj.content_elements.length; idx++) {
      let contentElement = rawStoryObj.content_elements[idx]
      if (contentElement.type === 'text') {
        textBody.push(contentElement.content)
      }
    }
    return textBody.join(' ')
  }
}
